import { Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/data';

const latestArticles = articles.slice(0, 6);

const articleImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20cinematic%20scene%20of%20a%20luxury%20hotel%20corridor%20at%20night%2C%20mysterious%20atmosphere%2C%20silhouette%20of%20two%20people%2C%20warm%20dim%20lighting%2C%20noir%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast%2C%20elegant%20composition%2C%20soft%20shadows&width=400&height=300&seq=latest-01&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=A%20dark%20minimalist%20scene%20with%20scattered%20financial%20documents%20on%20a%20glossy%20black%20desk%2C%20dramatic%20lighting%20from%20above%2C%20red%20seal%20stamps%2C%20luxury%20atmosphere%2C%20editorial%20style%2C%20dark%20background%2C%20cinematic%20mood%2C%20high%20contrast&width=400&height=300&seq=latest-02&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=A%20dark%20TV%20studio%20set%20with%20dramatic%20red%20and%20blue%20stage%20lighting%2C%20empty%20chairs%2C%20tense%20atmosphere%2C%20scattered%20props%20on%20floor%2C%20cinematic%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast&width=400&height=300&seq=latest-03&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=An%20empty%20movie%20theater%20with%20red%20seats%20in%20darkness%2C%20single%20projector%20beam%20cutting%20through%2C%20eerie%20atmosphere%2C%20cinematic%20noir%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast&width=400&height=300&seq=latest-04&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=A%20dark%20scene%20of%20a%20streaming%20studio%20with%20multiple%20screens%20showing%20chat%20messages%2C%20dim%20pink%20and%20purple%20ambient%20lighting%2C%20empty%20gaming%20chair%2C%20cyberpunk%20vibe%2C%20dark%20background%2C%20editorial%20photography&width=400&height=300&seq=latest-05&orientation=landscape',
  6: 'https://readdy.ai/api/search-image?query=A%20dark%20dramatic%20scene%20of%20a%20director%20chair%20on%20an%20empty%20film%20set%2C%20spotlight%20casting%20long%20shadows%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast&width=400&height=300&seq=latest-06&orientation=landscape',
};

export default function LatestArticles() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-12 gap-3">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 mb-2">
              最新爆料
            </h2>
            <p className="text-foreground-400 text-sm md:text-base">
              全网最快最热的一手瓜源
            </p>
          </div>
          <Link
            to="/category/mingxing-heidong"
            className="text-primary-400 text-sm hover:text-primary-300 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => {
            const category = categories.find((c) => c.slug === article.category);
            return (
              <article
                key={article.id}
                className="group relative rounded-xl overflow-hidden bg-background-200/80 border border-white/10 hover:border-primary-500/30 transition-all duration-300"
              >
                <Link to={`/article/${article.id}`} className="block">
                  <div className="relative h-48 md:h-52 overflow-hidden">
                    <img
                      src={articleImages[article.id]}
                      alt={article.title}
                      title={`${article.title} - 51爆料网`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-background-200/90 via-transparent to-transparent" />
                    {category && (
                      <span className="absolute top-3 left-3 px-3 py-1 bg-secondary-500/90 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                        {category.name}
                      </span>
                    )}
                    {article.tag && (
                      <span className="absolute top-3 right-3 px-3 py-1 bg-accent-500/90 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                        {article.tag}
                      </span>
                    )}
                  </div>
                  <div className="p-5">
                    <h3 className="text-foreground-100 font-heading font-semibold text-sm leading-snug line-clamp-2 group-hover:text-primary-400 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-foreground-500 text-sm mt-3 line-clamp-2 leading-relaxed">
                      {article.summary}
                    </p>
                    <div className="flex items-center gap-4 mt-4 text-foreground-600 text-xs">
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line" />
                        {article.views >= 10000
                          ? `${(article.views / 10000).toFixed(1)}万`
                          : article.views}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-chat-3-line" />
                        {article.comments}
                      </span>
                      <span className="ml-auto text-foreground-700">
                        {article.publishDate}
                      </span>
                    </div>
                  </div>
                </Link>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}